export default __webpack_public_path__ + "static/social media 3-0a5728c01f24f9d05ffeda357e66f45e.webp";